/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import ViewTeam from "../ViewTeam";
import pdficon from "../../../assests/word (2).png";
import wordicon from "../../../assests/word (1).png";
import arrow from "../../../assests/arrow_17004509.png";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Form, Input, Typography, Button, Divider, Select, Tag } from "antd";
import { FilePdfOutlined, FileWordOutlined, CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import CircularPercentage from "../../../components/CircularPercentage";
import { Radio, Checkbox, Space, Card } from "antd";

const { TextArea } = Input;
const { Title, Text } = Typography

export default function HodOneEdit({ data, onBack }) {
    const { authData, backUrl } = useContext(AuthContext);
    const isSuperUser = !!(
        authData?.employee?.is_superuser ||
        authData?.user?.is_superuser ||
        authData?.is_superuser
    );

    const [mrfDetails, setMrfDetails] = useState(null);
    const [error, setError] = useState("");
    const [showData, setShowData] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [designation, setDesignations] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [workLocation, setWorkLocation] = useState([]);
    const [errors, setErrors] = useState({});

    // HR Approval & Allocation states
    const [hrTeam, setHrTeam] = useState([]);
    const [hrApproved, setHrApproved] = useState(null);
    const [hrRemarks, setHrRemarks] = useState("");
    const [allocatedTo, setAllocatedTo] = useState(null);
    const [hrLoader, setHrLoader] = useState(false);
    const [hrErrors, setHrErrors] = useState({});

    const [taken, setTaken] = useState(0)


    const fetchData = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/manpowerrequisitions/${data}/`,
                {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            setMrfDetails(res.data);
        } catch (err) {
            console.error("Fetch error:", err);
            setError("Failed to fetch MRF data.");
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`, {
                headers: {
                    'Authorization': `Bearer ${authData.access}`,
                    'Content-Type': 'application/json',
                },
            });
            setOrganizationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchWorkLocation = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/worklocation/`);
            setWorkLocation(res.data.results);
            console.log("workLocation", res.data.results)
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    }

    const fetchDepartments = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/`);
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchDesignations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/`);
            setDesignations(res.data.results);
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (mrfDetails?.manager_approved === undefined || mrfDetails?.manager_approved === null) {
            newErrors.manager_approved = "Please select Approved or Rejected.";
        }

        if (mrfDetails?.manager_approved === false) {
            if (!mrfDetails?.manager_remarks?.trim()) {
                newErrors.manager_remarks = "Remarks are required.";
            }
        } else if (mrfDetails?.manager_approved === true || mrfDetails?.manager_approved === 1) {
            if (!mrfDetails?.mrf_salary_from) {
                newErrors.mrf_salary_from = "Salary from is required.";
            }
            if (!mrfDetails?.mrf_salary_to) {
                newErrors.mrf_salary_to = "Salary to is required.";
            }
            if (!mrfDetails?.manager_remarks?.trim()) {
                newErrors.manager_remarks = "Remarks are required.";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const fetchHrTeam = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/employees/?department=25`, {
                headers: {
                    'Authorization': `Bearer ${authData?.access}`,
                    'Content-Type': 'application/json',
                },
            });
            const team = Array.isArray(res.data) ? res.data : (res.data.results || []);
            setHrTeam(team);
        } catch (err) {
            console.error("Failed to fetch HR team:", err);
        }
    };

    useEffect(() => {
        fetchData();
        fetchDepartments();
        fetchDesignations();
        fetchOrganizations();
        fetchWorkLocation();
        fetchHrTeam();
    }, []);

    useEffect(() => {
        if (mrfDetails) {
            if (mrfDetails.hr_approved === 1 || mrfDetails.hr_approved === true) {
                setHrApproved(true);
            } else if (mrfDetails.hr_approved === 0 || mrfDetails.hr_approved === false) {
                setHrApproved(false);
            } else {
                setHrApproved(null);
            }
            setHrRemarks(mrfDetails.hr_remarks || "");
            setAllocatedTo(mrfDetails.mrf_allocated_to || null);
        }
    }, [mrfDetails]);

    const getOrganizationName = (id) => organizationNames.find(o => o.id === id)?.name || id || "-";
    const getDepartmentName = (id) => departments.find(dep => dep.id === id)?.name || id || "-";
    const getDesignationTitle = (id) => designation.find(des => des.id === id)?.name || id || "-";

    const handleClick = () => {
        if (onBack) {
            onBack();
        } else {
            setShowData(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setMrfDetails({ ...mrfDetails, [name]: newValue });
    };

    const [loader, setLoader] = useState(false);

    const handleSubmit = async () => {
        try {
            setLoader(true);
            if (!validateForm()) {
                toast.error("Please fill all required fields.");
                return;
            }

            const payload = {
                ...mrfDetails,
                manager_approved: mrfDetails.manager_approved ? 1 : 0,
            };

            // If superuser has selected HR coordinator or HR decision, include in payload
            if (isSuperUser) {
                if (allocatedTo && String(allocatedTo) !== "0") {
                    payload.mrf_allocated_to = allocatedTo;
                }
                if (hrApproved !== null && hrApproved !== undefined) {
                    payload.hr_approved = hrApproved ? 1 : 0;
                }
                if (hrRemarks) {
                    payload.hr_remarks = hrRemarks;
                }
            }

            const res = await axios.put(
                `${backUrl}/api/emp/manpowerrequisitions/${data}/manager_approve/`,
                payload,
                {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            toast.success(res.data.message || "HOD Approval submitted successfully!");
            await fetchData();
            if (!isSuperUser) {
                if (onBack) onBack();
                else setShowData(false);
            }
        } catch (err) {
            console.error("Update error:", err);

            let errorMessage = "Something went wrong";
            if (err.response?.data) {
                if (typeof err.response.data === "string") {
                    errorMessage = err.response.data;
                } else if (err.response.data.message) {
                    errorMessage = err.response.data.message;
                } else if (err.response.data.detail) {
                    errorMessage = err.response.data.detail;
                } else {
                    const firstKey = Object.keys(err.response.data)[0];
                    errorMessage = Array.isArray(err.response.data[firstKey])
                        ? err.response.data[firstKey][0]
                        : err.response.data[firstKey];
                }
            } else if (err.message) {
                errorMessage = err.message;
            }

            toast.error(errorMessage);
            setError(errorMessage);
        } finally {
            setLoader(false);
        }
    };

    const handleHrSubmit = async () => {
        const newHrErrors = {};
        if (hrApproved === null || hrApproved === undefined) {
            newHrErrors.hr_approved = "Please select Sanctioned or Rejected.";
        }
        if (hrApproved === true && (!allocatedTo || String(allocatedTo) === "0")) {
            newHrErrors.allocatedTo = "Assign any HR to coordinate the hiring process.";
        }
        if (hrApproved === false && !hrRemarks?.trim()) {
            newHrErrors.hr_remarks = "Remarks are required when rejecting.";
        }

        if (Object.keys(newHrErrors).length > 0) {
            setHrErrors(newHrErrors);
            toast.error(Object.values(newHrErrors)[0]);
            return;
        }
        setHrErrors({});

        try {
            setHrLoader(true);
            const payload = {
                hr_approved: hrApproved ? 1 : 0,
                hr_remarks: hrRemarks,
                mrf_allocated_to: allocatedTo || null,
                mrf_salary_from: mrfDetails.mrf_salary_from,
                mrf_salary_to: mrfDetails.mrf_salary_to,
            };

            const res = await axios.put(
                `${backUrl}/api/emp/manpowerrequisitions/${data}/hr_approve/`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${authData.access}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            toast.success(res.data.message || "HR approval & allocation saved successfully!");
            await fetchData();
        } catch (err) {
            console.error("HR submit error:", err);
            let errorMessage = "Something went wrong";
            if (err.response?.data?.message) {
                errorMessage = err.response.data.message;
            } else if (err.response?.data?.detail) {
                errorMessage = err.response.data.detail;
            } else if (typeof err.response?.data === "string") {
                errorMessage = err.response.data;
            }
            toast.error(errorMessage);
        } finally {
            setHrLoader(false);
        }
    };

    const fetchTaken = async () => {
        const res = await axios.get(`${backUrl}/api/emp/candidates/?offerletter_status=ACCEPTED&requisition_id=${mrfDetails.id}`,
            {
                headers: {
                    'Authorization': `Bearer ${authData.access}`,
                    'Content-Type': 'application/json',
                },
            });
        setTaken(res.data.count)
        console.log(mrfDetails.id)
    }


    useEffect(() => {
        if (mrfDetails?.id) {
            fetchTaken();
        }
    }, [mrfDetails]);

    return (
        <div className="view-container">
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
            {showData ? (
                <>
                    {/* {error} */}
                    {!mrfDetails ? (
                        <p>Loading MRF Details...</p>
                    ) : (
                        <>
                            <button className="bread" onClick={handleClick}>
                                ← Back to List
                            </button>

                            <div className="d-flex justify-content-center align-items-center">
                                <section>
                                    <center><h5>Manpower Requisition Form</h5></center>
                                    {/* <center>
                                        <h6 id={mrfDetails.mrf_status === 'Open' ? "status-indicator-green" : "status-indicator-gray"}>CURRENT STATUS -{" "}
                                            {mrfDetails.mrf_status === "Close" ? "Closed" : mrfDetails.mrf_status}</h6>
                                    </center> */}
                                </section>
                                {
                                    mrfDetails.status === "Sanctioned" && (
                                        <section className="mx-5">
                                            {/* <Text level={4}>Completion status</Text> */}
                                            <CircularPercentage vacancies={mrfDetails.no_of_vacancies} taken={taken} />

                                        </section>
                                    )
                                }
                            </div>
                            <div className="form container">
                                <div>
                                    <label>Organization</label>
                                    <input type="text" name="organisation" value={getOrganizationName(mrfDetails.organisation)} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>Department</label>
                                    <input type="text" name="department" value={getDepartmentName(mrfDetails.department)} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>Designation</label>
                                    <input type="text" name="designation" value={getDesignationTitle(mrfDetails.designation)} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>Site/Location</label>
                                    <input type="text" name="site_location" value={mrfDetails.site_location || ""} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>Required By</label>
                                    <input type="text" name="required_by" value={mrfDetails.required_by || ""} onChange={handleChange} readOnly />
                                </div>
                                <div>
                                    <label>No. of Vacancies</label>
                                    <input type="text" name="no_of_vacancies" value={mrfDetails.no_of_vacancies || ""} onChange={handleChange} readOnly />
                                </div>
                            </div>

                            <center>
                                <div id="center-area">
                                    <div id="requisition-type">
                                        <Form.Item label="Requisition Type">
                                            <Input value={mrfDetails.requisition_type || ""} readOnly />
                                        </Form.Item>
                                    </div>
                                    {
                                        mrfDetails.hr_approved && (
                                            <>

                                                <div id="download-area">
                                                    <>
                                                        <Typography.Text>
                                                            Download
                                                        </Typography.Text>
                                                        <Button
                                                            type="link"
                                                            icon={<FilePdfOutlined style={{ fontSize: '30px' }} />}
                                                            onClick={async (e) => {
                                                                e.preventDefault();
                                                                try {
                                                                    const response = await axios.get(
                                                                        `${backUrl}/api/emp/mrf/${mrfDetails.mrf_number}/download/?type=1`,
                                                                        { responseType: 'blob' }
                                                                    );

                                                                    const disposition = response.headers['content-disposition'];
                                                                    let filename = 'download.pdf';
                                                                    if (disposition && disposition.includes('filename=')) {
                                                                        filename = disposition
                                                                            .split('filename=')[1]
                                                                            .replace(/['"]/g, '')
                                                                            .trim();
                                                                    }

                                                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                                                    const link = document.createElement('a');
                                                                    link.href = url;
                                                                    link.setAttribute('download', filename);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                    window.URL.revokeObjectURL(url);
                                                                } catch (error) {
                                                                    console.error('PDF download failed', error);
                                                                }
                                                            }}
                                                        />

                                                        <Button
                                                            type="link"
                                                            icon={<FileWordOutlined style={{ fontSize: '30px' }} />}
                                                            onClick={async (e) => {
                                                                e.preventDefault();
                                                                try {
                                                                    const response = await axios.get(
                                                                        `${backUrl}/api/emp/mrf/${mrfDetails.mrf_number}/download/?type=2`,
                                                                        { responseType: 'blob' }
                                                                    );

                                                                    const disposition = response.headers['content-disposition'];
                                                                    let filename = 'download.docx';
                                                                    if (disposition && disposition.includes('filename=')) {
                                                                        filename = disposition
                                                                            .split('filename=')[1]
                                                                            .replace(/['"]/g, '')
                                                                            .trim();
                                                                    }

                                                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                                                    const link = document.createElement('a');
                                                                    link.href = url;
                                                                    link.setAttribute('download', filename);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                    window.URL.revokeObjectURL(url);
                                                                } catch (error) {
                                                                    console.error('Word download failed', error);
                                                                }
                                                            }}
                                                        />
                                                    </>
                                                </div>

                                            </>
                                        )
                                    }

                                </div>
                            </center>

                            <hr />
                            <div className="form-2">
                                <div className="deployment-area">
                                    <h3>Deployment</h3>
                                    <label>Place Of Work </label>
                                    <input
                                        type="text"
                                        name="place_of_work"

                                        value={
                                            Array.isArray(mrfDetails.place_of_work)
                                                ? mrfDetails.place_of_work.join(", ")
                                                : ""
                                        }
                                        readOnly
                                    />
                                    {/* <input
                                        type="text"
                                        value={
                                            Array.isArray(selectedReq.place_of_work)
                                                ? selectedReq.place_of_work.join(", ")
                                                : ""
                                            }
                                            readOnly
                                        /> */}
                                    {/* <label>Reporting To</label>
                                    <input type="text" name="reporting_to" value={mrfDetails.reporting_to || ""} onChange={handleChange} /> */}
                                    <label>Job Description</label>
                                    <textarea name="job_description" value={mrfDetails.job_description || ""} onChange={handleChange} readOnly />

                                    <a
                                        className="jd-anchor"
                                        href={mrfDetails.job_description_attachment}
                                        style={{
                                            background: 'transparent',
                                            color: 'black',
                                            textDecoration: 'none'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = 'black';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = 'black';
                                        }}
                                    >
                                        JD Attachment : View File
                                    </a>


                                    <h5 className={mrfDetails.manager_approved === false && "d-none"}>Salary Range</h5>
                                    <label className={mrfDetails.manager_approved === false && "d-none"}>From</label>
                                    <input className={mrfDetails.manager_approved === false && "d-none"} type="number" name="mrf_salary_from" value={mrfDetails.mrf_salary_from || ""} onChange={handleChange} />
                                    {errors.mrf_salary_from && <p style={{ color: 'red', fontSize: '12px' }}>{errors.mrf_salary_from}</p>}
                                    <label className={mrfDetails.manager_approved === false && "d-none"}>To</label>
                                    <input className={mrfDetails.manager_approved === false && "d-none"} type="number" name="mrf_salary_to" value={mrfDetails.mrf_salary_to || ""} onChange={handleChange} />
                                    {errors.mrf_salary_to && <p style={{ color: 'red', fontSize: '12px' }}>{errors.mrf_salary_to}</p>}


                                </div>

                                <div className="requirement-profile">
                                    <h3>Requirement Profile</h3>
                                    <label>Qualification</label>
                                    <input type="text" name="qualification" value={mrfDetails.qualification || ""} onChange={handleChange} readOnly />
                                    <label>Experience</label>
                                    <input type="text" name="experience" value={mrfDetails.experience || ""} onChange={handleChange} readOnly />
                                    <label>Skill Sets</label>
                                    <textarea name="skill_sets" value={mrfDetails.skill_sets || ""} onChange={handleChange} />
                                    <label>Any Other Requirements</label>
                                    <textarea name="other_requirements" value={mrfDetails.other_requirements || ""} onChange={handleChange} readOnly />
                                    <label>Justification</label>
                                    <textarea name="justification" value={mrfDetails.justification || ""} onChange={handleChange} readOnly />
                                </div>
                            </div>

                            {mrfDetails.requisition_type === 'Replacement' && (
                                <>
                                    <h3>If Replacement</h3>
                                    <div className="replacement-form">
                                        <label>Name of the Leaving Employee</label>
                                        <input type="text" name="name_of_leaving_employee" value={mrfDetails.name_of_leaving_employee || ""} onChange={handleChange} readOnly />
                                        <label>Date of Leaving</label>
                                        <input type="text" name="date_of_leaving" value={mrfDetails.date_of_leaving || ""} onChange={handleChange} readOnly />
                                        <label>Reason for Leaving</label>
                                        <textarea name="reason_for_leaving" value={mrfDetails.reason_for_leaving || ""} onChange={handleChange} readOnly />
                                        <label>Present Strength in the Category</label>
                                        <input type="text" name="present_dept_strength" value={mrfDetails.present_dept_strength || ""} onChange={handleChange} readOnly />
                                        <label>Strength of the Function</label>
                                        <input type="text" name="strength_of_function" value={mrfDetails.strength_of_function || ""} onChange={handleChange} readOnly />
                                        <label>Remarks</label>
                                        <textarea name="replacement_remarks" value={mrfDetails.replacement_remarks || ""} onChange={handleChange} readOnly />
                                    </div>
                                </>
                            )}

                            <div>
                                {/* HOD APPROVAL SECTION */}
                                <Card
                                    style={{
                                        maxWidth: 1200,
                                        margin: "20px auto",
                                        padding: 24,
                                        borderRadius: 12,
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                        backgroundColor: '#fafcff',
                                        border: '1px solid #c2d3e0'
                                    }}
                                >
                                    <center>
                                        <Title level={4} style={{ textAlign: "center", marginBottom: 16, color: "#0e497b" }}>
                                            HOD / Manager Approval
                                        </Title>

                                        {mrfDetails.manager_approved === 1 ? (
                                            <div style={{ maxWidth: 650, margin: "0 auto", textAlign: "center", padding: "16px", background: "#f6ffed", border: "1px solid #b7eb8f", borderRadius: "8px" }}>
                                                <Tag color="green" style={{ fontSize: "14px", padding: "4px 12px", marginBottom: "8px" }}>
                                                    <CheckCircleOutlined /> Manager Approved
                                                </Tag>
                                                {mrfDetails.manager_approval_date && (
                                                    <p style={{ margin: "4px 0", color: "#555", fontSize: "13px" }}>
                                                        <strong>Approval Date:</strong> {mrfDetails.manager_approval_date}
                                                    </p>
                                                )}
                                                {mrfDetails.manager_remarks && (
                                                    <p style={{ margin: "4px 0", color: "#333", fontSize: "14px" }}>
                                                        <strong>Manager Remarks:</strong> {mrfDetails.manager_remarks}
                                                    </p>
                                                )}
                                                {(mrfDetails.mrf_salary_from || mrfDetails.mrf_salary_to) && (
                                                    <p style={{ margin: "4px 0", color: "#333", fontSize: "14px" }}>
                                                        <strong>Salary Range:</strong> ₹{mrfDetails.mrf_salary_from || 0} - ₹{mrfDetails.mrf_salary_to || 0}
                                                    </p>
                                                )}
                                            </div>
                                        ) : mrfDetails.manager_approved === 0 ? (
                                            <div style={{ maxWidth: 650, margin: "0 auto", textAlign: "center", padding: "16px", background: "#fff2f0", border: "1px solid #ffccc7", borderRadius: "8px" }}>
                                                <Tag color="red" style={{ fontSize: "14px", padding: "4px 12px", marginBottom: "8px" }}>
                                                    <CloseCircleOutlined /> Rejected by Manager
                                                </Tag>
                                                {mrfDetails.manager_approval_date && (
                                                    <p style={{ margin: "4px 0", color: "#555", fontSize: "13px" }}>
                                                        <strong>Rejection Date:</strong> {mrfDetails.manager_approval_date}
                                                    </p>
                                                )}
                                                {mrfDetails.manager_remarks && (
                                                    <p style={{ margin: "4px 0", color: "#333", fontSize: "14px" }}>
                                                        <strong>Manager Remarks:</strong> {mrfDetails.manager_remarks}
                                                    </p>
                                                )}
                                            </div>
                                        ) : (
                                            <Space direction="vertical" size="middle" style={{ width: "100%", maxWidth: 650 }}>
                                                <Radio.Group
                                                    onChange={(e) => setMrfDetails({ ...mrfDetails, manager_approved: e.target.value })}
                                                    value={
                                                        mrfDetails.manager_approved === 1
                                                            ? true
                                                            : mrfDetails.manager_approved === 0
                                                                ? false
                                                                : mrfDetails.manager_approved
                                                    }
                                                    style={{ display: "flex", justifyContent: "center", gap: 20 }}
                                                >
                                                    <Radio value={true} style={{ fontSize: "15px" }}>Approved</Radio>
                                                    <Radio value={false} style={{ fontSize: "15px" }}>Rejected</Radio>
                                                </Radio.Group>
                                                {errors.manager_approved && <Text type="danger">{errors.manager_approved}</Text>}

                                                <TextArea
                                                    name="manager_remarks"
                                                    value={mrfDetails.manager_remarks || ""}
                                                    onChange={handleChange}
                                                    placeholder="Enter Manager Remarks"
                                                    rows={4}
                                                    style={{ width: "100%", maxWidth: "500px" }}
                                                />
                                                {errors.manager_remarks && <Text type="danger">{errors.manager_remarks}</Text>}

                                                <div style={{ textAlign: "center", marginTop: 8 }}>
                                                    <Button
                                                        type="primary"
                                                        onClick={handleSubmit}
                                                        style={{ backgroundColor: "#0e497b", borderColor: "#0e497b", minWidth: 160, height: 38, fontWeight: 600 }}
                                                        loading={loader}
                                                        disabled={loader}
                                                    >
                                                        Submit HOD Approval
                                                    </Button>
                                                </div>
                                            </Space>
                                        )}
                                    </center>
                                </Card>

                                <Divider />

                                {/* HR APPROVAL & ALLOCATION SECTION */}
                                {isSuperUser ? (
                                    <Card
                                        style={{
                                            maxWidth: 1200,
                                            margin: "20px auto",
                                            padding: 24,
                                            borderRadius: 12,
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                                            backgroundColor: "#f7faff",
                                            border: "1px solid #b8d2eb"
                                        }}
                                    >
                                        <center>
                                            <Title level={4} style={{ textAlign: "center", color: "#0e497b", marginBottom: 6 }}>
                                                HR Approval & HR Allocation
                                            </Title>
                                            <Text type="secondary" style={{ display: "block", marginBottom: 20, fontSize: "13px" }}>
                                                Superuser Panel: Perform HR approval/rejection and assign an HR coordinator for the recruitment process
                                            </Text>

                                            <Space direction="vertical" size="large" style={{ width: "100%", maxWidth: 650 }}>
                                                {/* Status Radios */}
                                                <div>
                                                    <Text strong style={{ display: "block", marginBottom: 8, fontSize: "14px" }}>
                                                        HR Approval Status <span style={{ color: "red" }}>*</span>
                                                    </Text>
                                                    <Radio.Group
                                                        name="hr_approved"
                                                        value={hrApproved}
                                                        onChange={(e) => {
                                                            setHrApproved(e.target.value);
                                                            if (hrErrors.hr_approved) setHrErrors(prev => ({ ...prev, hr_approved: null }));
                                                        }}
                                                        style={{ display: "flex", justifyContent: "center", gap: 30 }}
                                                    >
                                                        <Radio value={true} style={{ fontSize: "15px" }}>Sanctioned</Radio>
                                                        <Radio value={false} style={{ fontSize: "15px" }}>Rejected</Radio>
                                                    </Radio.Group>
                                                    {hrErrors.hr_approved && <p style={{ color: 'red', fontSize: '12px', marginTop: 4 }}>{hrErrors.hr_approved}</p>}
                                                </div>

                                                {/* Remarks */}
                                                <div style={{ textAlign: "left" }}>
                                                    <Text strong style={{ display: "block", marginBottom: 6 }}>
                                                        HR Remarks {hrApproved === false && <span style={{ color: "red" }}>*</span>}
                                                    </Text>
                                                    <TextArea
                                                        rows={4}
                                                        placeholder="Enter HR approval or rejection remarks"
                                                        name="hr_remarks"
                                                        value={hrRemarks}
                                                        onChange={(e) => {
                                                            setHrRemarks(e.target.value);
                                                            if (hrErrors.hr_remarks) setHrErrors(prev => ({ ...prev, hr_remarks: null }));
                                                        }}
                                                        style={{ width: "100%", borderRadius: "6px" }}
                                                    />
                                                    {hrErrors.hr_remarks && <p style={{ color: 'red', fontSize: '12px', marginTop: 4 }}>{hrErrors.hr_remarks}</p>}
                                                </div>

                                                {/* HR Allocation Dropdown */}
                                                <div style={{ textAlign: "left" }}>
                                                    <Text strong style={{ display: "block", marginBottom: 6 }}>
                                                        Allocate HR Coordinator {hrApproved === true && <span style={{ color: "red" }}>*</span>}
                                                    </Text>
                                                    <Select
                                                        showSearch
                                                        placeholder="-- Select HR Coordinator --"
                                                        style={{ width: "100%" }}
                                                        allowClear
                                                        value={allocatedTo || undefined}
                                                        onChange={(value) => {
                                                            setAllocatedTo(value);
                                                            if (hrErrors.allocatedTo) setHrErrors(prev => ({ ...prev, allocatedTo: null }));
                                                        }}
                                                        filterOption={(input, option) =>
                                                            (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {hrTeam.map((item) => {
                                                            const empName = `${item.first_name || item.user?.first_name || ""} ${item.last_name || item.user?.last_name || ""}`.trim();
                                                            const code = item.emp_code ? ` (${item.emp_code})` : "";
                                                            return (
                                                                <Select.Option key={item.id} value={item.id}>
                                                                    {empName || "Employee"} {code}
                                                                </Select.Option>
                                                            );
                                                        })}
                                                    </Select>
                                                    {hrErrors.allocatedTo && <p style={{ color: 'red', fontSize: '12px', marginTop: 4 }}>{hrErrors.allocatedTo}</p>}
                                                    <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 4 }}>
                                                        Assigned HR will coordinate hiring, schedule interviews, and issue offers.
                                                    </Text>
                                                </div>

                                                {/* Submit Button */}
                                                <div style={{ textAlign: "center", marginTop: 10 }}>
                                                    <Button
                                                        type="primary"
                                                        onClick={handleHrSubmit}
                                                        style={{
                                                            backgroundColor: "#0e497b",
                                                            borderColor: "#0e497b",
                                                            height: "42px",
                                                            padding: "0 32px",
                                                            fontSize: "15px",
                                                            fontWeight: 600,
                                                            borderRadius: "6px"
                                                        }}
                                                        loading={hrLoader}
                                                        disabled={hrLoader}
                                                    >
                                                        Submit HR Approval & Allocation
                                                    </Button>
                                                </div>
                                            </Space>
                                        </center>
                                    </Card>
                                ) : (
                                    (mrfDetails.status === "Sanctioned" || mrfDetails.status === "Rejected") && (
                                        <center>
                                            <div className="p-4" id="approval-hr" style={{ textAlign: "center" }}>
                                                <Title level={4}>HR Approval Status</Title>
                                                <br />
                                                <div className="approval-area">
                                                    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                                                        <Radio.Group name="hr_approved" value={mrfDetails.hr_approved} disabled>
                                                            <Radio value={true}>Sanctioned</Radio>
                                                            <Radio value={false}>Rejected</Radio>
                                                        </Radio.Group>
                                                        <Input.TextArea
                                                            rows={4}
                                                            placeholder="Enter remarks"
                                                            name="hr_remarks"
                                                            value={mrfDetails.hr_remarks || ""}
                                                            readOnly
                                                            style={{ maxWidth: '500px' }}
                                                        />
                                                    </Space>
                                                </div>
                                                <br />
                                                {mrfDetails.mrf_allocated_to && (
                                                    <Select
                                                        placeholder="Select HR"
                                                        style={{ width: 220 }}
                                                        value={mrfDetails.mrf_allocated_to}
                                                        disabled
                                                    >
                                                        <Select.Option value={mrfDetails.mrf_allocated_to}>
                                                            {mrfDetails.mrf_allocated_to_display || "Allocated HR"}
                                                        </Select.Option>
                                                    </Select>
                                                )}
                                            </div>
                                        </center>
                                    )
                                )}
                            </div>

                        </>
                    )}
                </>
            ) : (
                <ViewTeam />
            )
            }
        </div >
    );
}